import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    height: 100%;
    overflow-x: hidden;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    max-width: 100vw;
    position: relative;
  }

  body {
    /* ✅ FIX: Явно указываем emoji fallback для всех тем */
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif !important;

    position: relative;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    max-width: 430px;
    margin: 0 auto;

    background: var(--tg-theme-bg-color, #ffffff);
    color: var(--tg-theme-text-color, #000000);

    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    -webkit-touch-callout: none;
  }

  #root {
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    max-width: 430px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-x: hidden;
  }

  :root {
    --telegram-width: 390px;
    --telegram-height: 844px;
    --safe-area-top: env(safe-area-inset-top, 0px);
    --safe-area-bottom: env(safe-area-inset-bottom, 0px);

    --primary-color: #7B68EE;
    --primary-dark: #6A5ACD;
    --accent-color: #87CEEB;

    --radius-sm: 8px;
    --radius-md: 12px;
    --radius-lg: 16px;
    --radius-xl: 20px;

    --container-padding: 16px;
    --card-padding: 16px;
    --button-height: 44px;
    --input-height: 44px;
    --header-height: 56px;
    --bottom-nav-height: 76px;

    --transition-fast: 0.15s ease;
    --transition-normal: 0.2s ease;
    --transition-slow: 0.3s ease;

    /* Light theme colors */
    --text-primary: #000000;
    --text-secondary: rgba(0, 0, 0, 0.7);
    --text-tertiary: rgba(0, 0, 0, 0.5);
    --text-on-primary: #ffffff;

    --bg-primary: #ffffff;
    --bg-secondary: #f8f7ff;
    --bg-tertiary: #f1f1f1;

    --surface-glass: linear-gradient(145deg, rgba(255,255,255,0.95), rgba(255,255,255,0.85));
    --surface-light: rgba(123, 104, 238, 0.05);
    --surface-medium: rgba(123, 104, 238, 0.1);

    --border-light: rgba(123, 104, 238, 0.1);
    --border-medium: rgba(123, 104, 238, 0.2);
    --border-strong: rgba(123, 104, 238, 0.3);

    --card-bg: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(255, 255, 255, 0.95));
    --modal-bg: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(248, 247, 255, 0.94));

    --shadow-sm: 0 2px 8px rgba(123, 104, 238, 0.1);
    --shadow-md: 0 4px 16px rgba(123, 104, 238, 0.15);
    --shadow-lg: 0 8px 32px rgba(123, 104, 238, 0.2);

    /* Brand gradients - light theme */
    --gradient-purple: linear-gradient(135deg, #7B68EE, #9966CC);
    --gradient-brand: linear-gradient(135deg, #7B68EE 0%, #9966CC 50%, #87CEEB 100%);
    --gradient-logo: linear-gradient(135deg, #7B68EE, #9966CC);

    /* Alert colors - light theme */
    --alert-info-bg: rgba(59, 130, 246, 0.1);
    --alert-info-border: rgba(59, 130, 246, 0.3);
    --alert-warning-bg: rgba(245, 158, 11, 0.1);
    --alert-warning-border: rgba(245, 158, 11, 0.3);
    --alert-danger-bg: rgba(239, 68, 68, 0.1);
    --alert-danger-border: rgba(239, 68, 68, 0.3);
    --alert-success-bg: rgba(34, 197, 94, 0.1);
    --alert-success-border: rgba(34, 197, 94, 0.3);
  }

  /* ✅ КНОПКИ - базовые стили БЕЗ hover (делегируем в компоненты) */
  button, .button {
    background: var(--button-bg, var(--tg-theme-secondary-bg-color, #f1f1f1));
    color: var(--button-color, var(--tg-theme-text-color, #000000));
    border: none;
    border-radius: var(--radius-md);
    font-weight: 500;
    font-size: 16px;
    padding: 12px 20px;
    transition: all var(--transition-normal);
    cursor: pointer;
    
    /* ❌ УДАЛЕНО: глобальный hover - он убивал контраст на primary кнопках */
    
    &:active {
      transform: translateY(0);
      opacity: 0.8;
    }
  }

  .button-primary, 
  button[data-variant="primary"] {
    background: var(--tg-theme-button-color, #7B68EE);
    color: var(--tg-theme-button-text-color, #ffffff);
  }

  .button-outline,
  button[data-variant="outline"] {
    background: transparent;
    border: 1px solid var(--tg-theme-button-color, #7B68EE);
    color: var(--tg-theme-button-color, #7B68EE);
    
    &:hover {
      background: var(--tg-theme-button-color, #7B68EE);
      color: var(--tg-theme-button-text-color, #ffffff);
    }
  }

  /* ✅ КАРТОЧКИ БЕЗ !important */
  .card {
    background: var(--tg-theme-secondary-bg-color, #f1f1f1);
    color: var(--tg-theme-text-color, #000000);
    border-radius: var(--radius-md);
    padding: var(--card-padding);
    margin-bottom: 8px;
    border: none;
    transition: all var(--transition-normal);
    
    &:hover {
      background: var(--tg-theme-bg-color, #ffffff);
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }

  /* ✅ ИНПУТЫ БЕЗ !important */
  input, textarea, select {
    background: var(--tg-theme-secondary-bg-color, #f1f1f1);
    color: var(--tg-theme-text-color, #000000);
    border: 1px solid transparent;
    border-radius: var(--radius-md);
    padding: 12px 16px;
    font-size: 16px;
    height: var(--input-height);
    transition: all var(--transition-normal);
    
    &::placeholder {
      color: var(--tg-theme-hint-color, rgba(0,0,0,0.5));
    }
    
    &:focus {
      background: var(--tg-theme-bg-color, #ffffff);
      border-color: var(--tg-theme-button-color, #7B68EE);
      outline: none;
      transform: translateY(-1px);
    }
  }

  /* ✅ NAVIGATION БЕЗ !important */
  .bottom-nav, 
[data-testid="bottom-navigation"],
  nav[role="navigation"] {
    background: var(--tg-theme-secondary-bg-color, #f1f1f1);
    border-top: 1px solid var(--tg-theme-secondary-bg-color, #e1e1e1);
    height: var(--bottom-nav-height);
    padding-bottom: var(--safe-area-bottom);
    
    .nav-label, 
    .bottom-nav-label,
    span {
      color: var(--tg-theme-text-color, #000000);
      font-weight: 500;
      font-size: 12px;
      display: block;
      visibility: visible;
    }
    
    .active .nav-label,
    .active span {
      color: var(--tg-theme-button-color, #7B68EE);
      font-weight: 600;
    }
  }

  .header {
    height: var(--header-height);
    background: var(--tg-theme-bg-color, #ffffff);
    border-bottom: 1px solid var(--tg-theme-secondary-bg-color, #e1e1e1);
    padding-top: var(--safe-area-top);
  }

  h1 { 
    font-size: clamp(22px, 5vw, 28px); 
    line-height: 1.2; 
    font-weight: 700; 
    margin-bottom: 12px;
    color: var(--tg-theme-text-color, #000000);
  }
  
  h2 { 
    font-size: clamp(18px, 4vw, 24px); 
    line-height: 1.3; 
    font-weight: 600; 
    margin-bottom: 10px;
    color: var(--tg-theme-text-color, #000000);
  }
  
  h3 { 
    font-size: clamp(16px, 3.5vw, 20px); 
    line-height: 1.3; 
    font-weight: 600; 
    margin-bottom: 8px;
    color: var(--tg-theme-text-color, #000000);
  }
  
  h4 { 
    font-size: clamp(14px, 3vw, 18px); 
    line-height: 1.4; 
    font-weight: 500; 
    margin-bottom: 6px;
    color: var(--tg-theme-text-color, #000000);
  }

  p { 
    font-size: 16px; 
    line-height: 1.5; 
    margin-bottom: 10px;
    color: var(--tg-theme-text-color, #000000);
  }
  
  small { 
    font-size: 14px; 
    line-height: 1.4;
    color: var(--tg-theme-hint-color, rgba(0,0,0,0.6));
  }

  .loading-spinner {
    width: 32px;
    height: 32px;
    border: 2px solid var(--tg-theme-secondary-bg-color, #e1e1e1);
    border-top: 2px solid var(--tg-theme-button-color, #7B68EE);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--tg-theme-hint-color, rgba(0,0,0,0.3));
    border-radius: 1px;
  }

  @media (max-width: 375px) {
    :root {
      --container-padding: 12px;
      --card-padding: 12px;
      --button-height: 40px;
      --input-height: 40px;
    }
    
    body {
      max-width: 375px;
    }
  }

  @media (min-width: 376px) and (max-width: 430px) {
    body {
      max-width: 430px;
    }
  }

  @media (min-width: 431px) and (max-width: 768px) {
    body {
      max-width: 430px;
    }
  }

  @media (min-width: 769px) {
    body {
      max-width: 430px;
      border: 1px solid var(--tg-theme-secondary-bg-color, #e1e1e1);
      border-radius: var(--radius-lg);
      margin-top: 20px;
      min-height: calc(100vh - 40px);
    }
    
    #root {
      border-radius: var(--radius-lg);
      overflow: hidden;
    }
  }

  .fade-in {
    animation: fadeIn 0.3s ease;
  }

  .slide-up {
    animation: slideUp 0.3s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from { 
      opacity: 0; 
      transform: translateY(20px); 
    }
    to { 
      opacity: 1; 
      transform: translateY(0); 
    }
  }

  .haptic-light:active {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms;
      animation-iteration-count: 1;
      transition-duration: 0.01ms;
    }
  }

  /* ✅ Dark theme через data-theme attribute (приоритет Telegram.WebApp.colorScheme) */
  :root[data-theme="dark"] {
    /* Dark theme colors */
    --text-primary: #ffffff;
    --text-secondary: rgba(255, 255, 255, 0.7);
    --text-tertiary: rgba(255, 255, 255, 0.5);
    --text-on-primary: #ffffff;

    --bg-primary: #1a1a2e;
    --bg-secondary: #16213e;
    --bg-tertiary: #0f3460;

    --surface-glass: linear-gradient(145deg, rgba(255,255,255,0.08), rgba(255,255,255,0.04));
    --surface-light: rgba(255, 255, 255, 0.05);
    --surface-medium: rgba(255, 255, 255, 0.1);

    --border-light: rgba(255, 255, 255, 0.1);
    --border-medium: rgba(255, 255, 255, 0.15);
    --border-strong: rgba(255, 255, 255, 0.2);

    --card-bg: linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(200, 200, 255, 0.02));
    --modal-bg: linear-gradient(135deg, rgba(42, 42, 60, 0.98), rgba(32, 32, 50, 0.95));

    --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
    --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.4);
    --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.5);

    /* Brand gradients - dark theme (lighter variants) */
    --gradient-purple: linear-gradient(135deg, #9d8eee, #b896dc);
    --gradient-brand: linear-gradient(135deg, #9d8eee 0%, #b896dc 50%, #a0d8f0 100%);
    --gradient-logo: linear-gradient(135deg, #C4B5FD, #D8B4FE);

    /* Alert colors - dark theme */
    --alert-info-bg: rgba(96, 165, 250, 0.15);
    --alert-info-border: rgba(96, 165, 250, 0.4);
    --alert-warning-bg: rgba(251, 191, 36, 0.15);
    --alert-warning-border: rgba(251, 191, 36, 0.4);
    --alert-danger-bg: rgba(248, 113, 113, 0.15);
    --alert-danger-border: rgba(248, 113, 113, 0.4);
    --alert-success-bg: rgba(74, 222, 128, 0.15);
    --alert-success-border: rgba(74, 222, 128, 0.4);
  }

  :root[data-theme="dark"] .card {
    background: var(--tg-theme-secondary-bg-color, #2d2d2d);
  }

  :root[data-theme="dark"] input,
  :root[data-theme="dark"] textarea,
  :root[data-theme="dark"] select {
    background: var(--tg-theme-secondary-bg-color, #2d2d2d);
  }

  :root[data-theme="dark"] .bottom-nav,
  :root[data-theme="dark"][data-testid="bottom-navigation"],
  :root[data-theme="dark"] nav[role="navigation"] {
    background: var(--tg-theme-secondary-bg-color, #2d2d2d);
    border-top-color: var(--tg-theme-secondary-bg-color, #3d3d3d);
  }
`;
